const navItems = [
  {
    name: "Home",
    link: "/"
  },
  {
    name: "About us",
    link: "/about-us"
  },
  {
    name: "Events",
    link: "/events"
  },
  // {
  //   name: "News",
  //   link: "/news"
  // },
  {
    name: "Contact",
    link: "/contact"
  },
  {
    name: "Join us",
    link: "/join-us",
    style: "button"
  }
];

export default navItems;